<style scoped="scoped" lang="scss"></style>
<style>
.el-select .el-input {
  width: 90px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/iqc/inspection/bill/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('iqcdanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>

          <el-form-item :label="$t('danjuzhuangtai')">
            <yi_dictionary_select :max="999" clearable type="IQC_ORDER_STATUS" :ids.sync="yt.conditions.status"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('caigoudingdanhao')">
            <el-input v-model="yt.conditions.purchaseOrderNo"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" v-if="scope.row.status === '1' && utils.checkPower('web_iqc_inspection_bill_update')" @click="yt.showEditDialog('luruzhijianjieguo', scope.row, null, beforeUpdate)">{{ $t('luruzhijianjieguo') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" v-if="scope.row.status === '2'" @click="yt.showEditDialog('chakanzhijianjieguo', scope.row)">{{ $t('chakanzhijianjieguo') }}</el-button>
          </el-col>
        </el-row>
      </template>
      <!-- 底部插槽 -->
      <!-- <div slot="footer"></div> -->
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'chakanzhijianjieguo'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('gongyingshangmingcheng')" class="noborder">
            <el-input :value="yt.editObj.supplier && yt.editObj.supplier.name" disabled=""></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('wuliaobianma')">
            <el-input :value="yt.editObj.material && yt.editObj.material.code" disabled=""></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('wuliaomingcheng')">
            <el-input :value="yt.editObj.material && yt.editObj.material.name" disabled=""></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('baojianshuliang')">
            <el-input :value="yt.editObj.inspectionQuantity" disabled=""></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('baojiandanwei')">
            <el-input :value="yt.editObj.inspectionUnit" disabled=""></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('jianyanjieguo')" required>
            <el-select :value="yt.editObj.inspectionResult" disabled="">
              <el-option :label="$t('hege')" :value="'1'"></el-option>
              <el-option :label="$t('buhege')" :value="'2'"></el-option>
            </el-select>
          </el-form-item>
          <div v-if="yt.editObj.inspectionResult === '2'">
            <el-form-item class="noborder" :label="$t('PROCESSING_MODE')" required>
              <el-select :value="yt.editObj.judgmentResult" disabled="">
                <el-option :label="$t('rangbujieshou')" :value="'1'"></el-option>
                <!--                <el-option :label="$t('tuihuoshenqing')" :value="'2'"></el-option>-->
                <el-option :label="$t('zhijianbohui')" :value="'4'"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item class="noborder" :label="$t('beizhu')">
            <el-input :value="yt.editObj.remark" disabled=""></el-input>
          </el-form-item>
          <div v-if="yt.editObj.inspectionResult === '2' && yt.editObj.judgmentResult === '2'">
            <el-form-item class="noborder" :label="$t('tuihuoshuliang')" required>
              <el-input :value="yt.editObj.returnQuantity" disabled=""></el-input>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('tuihuodizhi')">
              <el-input :value="yt.editObj.returnAddress || yt.editObj.supplier.address" disabled=""></el-input>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('tuihuoyuanying')">
              <el-input :value="yt.editObj.returnReason" disabled=""></el-input>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
        </span>
      </template>
      <!-- 录入质检结果表单 -->
      <template v-if="yt.editObj.action == 'luruzhijianjieguo'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('gongyingshangmingcheng')" class="noborder">
            <el-input v-model="yt.editObj.supplier.name" disabled=""></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('wuliaobianma')">
            <el-input v-model="yt.editObj.material.code" disabled=""></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('wuliaomingcheng')">
            <el-input v-model="yt.editObj.material.name" disabled=""></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('baojianshuliang')">
            <el-input v-model="yt.editObj.inspectionQuantity" disabled=""></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('baojiandanwei')">
            <el-input v-model="yt.editObj.inspectionUnit" disabled=""></el-input>
          </el-form-item>

          <el-form-item :label="$t('jianyanjieguo')" required>
            <el-select v-model="yt.editObj.inspectionResult">
              <el-option :label="$t('hege')" :value="'1'"></el-option>
              <el-option :label="$t('buhege')" :value="'2'"></el-option>
            </el-select>
          </el-form-item>
          <div v-if="yt.editObj.inspectionResult === '2'">
            <el-form-item :label="$t('PROCESSING_MODE')" required>
              <el-select v-model="yt.editObj.judgmentResult">
                <el-option :label="$t('rangbujieshou')" :value="'1'"></el-option>
                <!-- <el-option :label="$t('tuihuoshenqing')" :value="'2'"></el-option> -->
                <el-option :label="$t('zhijianbohui')" :value="'4'"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-if="yt.editObj.inspectionResult === '2' && yt.editObj.judgmentResult === '2'">
            <el-form-item :label="$t('tuihuoshuliang')" required>
              <el-input v-model="yt.editObj.returnQuantity"></el-input>
            </el-form-item>
            <el-form-item :label="$t('tuihuodizhi')">
              <el-input v-model="yt.editObj.supplier.address"></el-input>
            </el-form-item>
            <el-form-item :label="$t('tuihuoyuanying')">
              <el-input v-model="yt.editObj.returnReason"></el-input>
            </el-form-item>
          </div>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/iqc/inspection/bill/enterQualityInspectionResults', beforeAdd)" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_iqc_inspection_bill',

  data() {
    return {
      show: false,
      columns: [
        {
          label: 'iqcdanhao',
          prop: 'no',
          width: 150
        },
        {
          label: 'danjuzhuangtai',
          prop: 'status',
          type: 'dictionary',
          key: 'IQC_ORDER_STATUS',
          width: 100
        },
        {
          label: 'jianyanjieguo',
          prop: 'inspectionResult',
          type: 'dictionary',
          key: 'TEST_RESULTS',
          width: 100
        },
        {
          label: 'pandingjieguo',
          prop: 'judgmentResult',
          type: 'dictionary',
          key: 'JUDGMENT_RESULTS',
          width: 100
        },
        {
          label: 'gongyingshangmingcheng',
          prop: 'supplier.name',
          width: 150
        },
        {
          label: 'gongyingshangdizhi',
          prop: 'supplier.address',
          width: 150
        },
        {
          label: 'caigoudingdanhao',
          prop: 'purchaseOrder.no',
          width: 150
        },
        {
          label: 'caigoudingdanhanghao',
          prop: 'purchaseOrderDetail.no',
          width: 150
        },
        {
          label: 'wuliaobianma',
          prop: 'material.code'
        },
        {
          label: 'wuliaomingcheng',
          prop: 'material.name'
        },
        {
          label: 'baojianshuliang',
          prop: 'inspectionQuantity'
        },
        {
          label: 'baojiandanwei',
          prop: 'inspectionUnit'
        },
        {
          label: 'tuihuoshuliang',

          prop: 'returnQuantity'
        },
        {
          label: 'jianyanyuan',
          prop: 'inspectorObject.nickname'
        },
        {
          label: 'jianyanshijian',

          prop: 'inspectionTime',
          type: 'time'
        },
        {
          label: 'beizhu',

          prop: 'remark'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 180,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },
  methods: {
    beforeUpdate(params) {
      params.supplier = {};
      params.material = {};
      return params;
    },
    beforeAdd(params, url) {
      if (params.inspectionResult === '2') {
        if (params.judgmentResult === '' || params.judgmentResult == null) {
          this.utils.errorMessage(this.$t('chulifangshibunengweikong'));
          return;
        }
        if (params.judgmentResult === '2') {
          if (params.returnQuantity === '' || params.returnQuantity == null) {
            this.utils.errorMessage(this.$t('tuihuoshuliangbunengweikong'));
            return;
          } else {
            const reg = /^\d+(?=.{0,1}\d+$|$)/;
            if (reg.test(params.returnQuantity)) {
              if (params.returnQuantity == '0') {
                this.utils.errorMessage(this.$t('qingshurudayulingdeshuliang'));
                return;
              }
              if (params.returnQuantity > params.inspectionQuantity) {
                this.utils.errorMessage(this.$t('tuihuoshuliangbunengdayubaojianshuliang'));
                return;
              }
            } else {
              this.utils.errorMessage(this.$t('qingshurushuzi'));
              return;
            }
          }
        }
      }
      return params;
    },

    // 重置
    clear() {
      this.yt.get(1);
    }
  }
};
</script>
